// extracted by mini-css-extract-plugin
export var copyableField = "_n0-4";
export var customerBadge = "_n0-0";
export var customerInfoTitle = "_n0-2";
export var details = "_n0-1";
export var dropdownContainer = "_n0-5";
export var dropdownImage = "_n0-6";
export var editAssigneeForm = "_n0-a";
export var editButton = "_n0-3";
export var email = "_n0-7";
export var hidden = "_n0-d";
export var input = "_n0-8";
export var saveButton = "_n0-b";
export var shopifyIcon = "_n0-c";
export var suggestionBadge = "_n0-e";
export var suggestionText = "_n0-f";
export var username = "_n0-9";